// extracted by mini-css-extract-plugin
module.exports = {"product":"HomePage_product__1kR_a"};